// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Banner_bannerWrapper__qhtIU","banner-img":"Banner_banner-img__fiGvI"};